import React from 'react';

type DotButtonProps = {
  selected: boolean;
  onClick: () => void;
  className: string;
  children?: React.ReactNode;
};

export const DotButton: React.FC<DotButtonProps> = ({ selected, onClick, className, children }) => (
  <button
    className={`${className} embla__dot${selected ? ' embla__dot--selected' : ''}`}
    type="button"
    onClick={onClick}
  >
    {children}
  </button>
);

export const useDotButton = (emblaApi: any) => {
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const scrollSnaps = emblaApi ? emblaApi.scrollSnapList() : [];

  const onDotButtonClick = (index: number) => {
    if (emblaApi) emblaApi.scrollTo(index);
  };

  React.useEffect(() => {
    if (!emblaApi) return;
    const onSelect = () => {
      setSelectedIndex(emblaApi.selectedScrollSnap());
    };
    emblaApi.on('select', onSelect);
    onSelect();
  }, [emblaApi]);

  return { selectedIndex, scrollSnaps, onDotButtonClick };
};
